module.exports = __webpack_public_path__ + "img/1-4.696ddda9.png";